module.exports = __webpack_public_path__ + "media/images/placeholder-25878368281d9e1fb6d6d42f3159f8d7.svg";